import { jsx as _jsx } from "react/jsx-runtime";
import scss from './CsSimpleButton.scss';
/**
 * 不带边框等附加样式的Button
 */
const CsSimpleButton = (props) => {
    const { children, onClick, style, className, ...restProps } = props;
    return (_jsx("div", { className: `${scss.csSimpleButton} ${className || ''}`, onClick: onClick, style: style, ...restProps, children: children }));
};
export default CsSimpleButton;
